/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: @loopback/repository-json-schema#Optional<Omit<EvaluationScores, \'id\'>, \'evaluationId\'>, schemaOptions: { title: \'NewEvaluationScoresInEvaluations\', exclude: [ \'id\' ], optional: [ \'evaluationId\' ] })
 */
export interface NewEvaluationScoresInEvaluations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    evaluationId?: string;
    relationTypeId?: string;
    score: number;
    scoreDisplay: number;
}

